import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Flex, Icon } from 'ui';
import { withRouter } from 'utils/withRouter';

const Amount = styled(Flex)`
  color: ${p => p.theme.colors.theme};
  font-size: 16px;
  font-weight: bold;
  margin-left: auto;
`;

const Title = styled.div`
`;

const StyledIcon = styled(Icon)`
  cursor: pointer;
  color: ${p => p.theme.colors.theme};
  margin-left: 10px;
  font-size: 14px;
`;

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: baseline;
  cursor: ${p => p.canClick ? 'pointer' : 'default'};
  &:hover {
    text-decoration: ${p => p.canClick ? 'underline' : 'unset'};
  }
`;

const KpiIndicator = ({ data, max = 999, history }) => <>
  {data?.map(d =>
    <Wrapper data-test-id={`kpi-indicator.${d.key}`} key={d.key} canClick={!!d.url} onClick={() => d.url && history.push(d.url)}>
      <Title>{d?.title}</Title>
      <Amount data-test-id='kpi-indicator-amount' ffrn>
        <div>{d.value > max ? max : d.value}</div>
        {d.value > max ? <div>+</div> : null}
      </Amount>
      <StyledIcon type='arrow-right' light={true} />
    </Wrapper>,
  )}
</>;

KpiIndicator.propTypes = {
  data: PropTypes.array,
  max: PropTypes.number,
  history: PropTypes.object,
};

export default withRouter(KpiIndicator);
